import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatDate } from "@/lib/api";
import { MaskedLine, FadeUp, Kicker } from "@/components/Reveal";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Blog — Luca Mannu Giardini";
    api.get("/posts").then((r) => setPosts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const [featured, ...rest] = posts;

  return (
    <main className="pt-32" data-testid="blog-page">
      <header className="mx-auto max-w-7xl px-6 lg:px-10">
        <Kicker>Il blog</Kicker>
        <h1 className="mt-4 font-serif text-5xl tracking-tight text-forest md:text-6xl">
          <MaskedLine delay={0.1}>Note di un</MaskedLine>
          <MaskedLine delay={0.22} className="italic text-moss">giardiniere.</MaskedLine>
        </h1>
        <FadeUp delay={0.35}>
          <p className="mt-6 max-w-xl leading-relaxed text-sage">
            Consigli di stagione, errori da evitare e piccole verità imparate con le mani nella terra.
          </p>
        </FadeUp>
      </header>

      <section className="mx-auto max-w-7xl px-6 pb-28 pt-16 lg:px-10">
        {loading && <p className="text-sage" data-testid="blog-loading">Caricamento articoli…</p>}
        {!loading && posts.length === 0 && (
          <p className="text-sage" data-testid="blog-empty">Nessun articolo pubblicato ancora. Torna presto.</p>
        )}
        {featured && (
          <FadeUp>
            <Link to={`/blog/${featured.slug}`} className="group grid gap-8 md:grid-cols-12 md:items-end" data-testid={`blog-featured-${featured.slug}`}>
              <div className="overflow-hidden rounded-sm bg-sand md:col-span-8">
                <img src={featured.image} alt={featured.title} className="aspect-[16/9] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="md:col-span-4">
                <p className="font-accent text-[10px] uppercase tracking-[0.22em] text-terra">{featured.category} · {formatDate(featured.created_at)}</p>
                <h2 className="mt-3 font-serif text-3xl leading-tight text-forest transition-colors duration-300 group-hover:text-moss md:text-4xl">{featured.title}</h2>
                <p className="mt-4 leading-relaxed text-sage">{featured.excerpt}</p>
              </div>
            </Link>
          </FadeUp>
        )}
        <div className="mt-20 grid gap-12 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map((p, i) => (
            <FadeUp key={p.id} delay={i * 0.1}>
              <Link to={`/blog/${p.slug}`} className="group block" data-testid={`blog-card-${p.slug}`}>
                <div className="arch-frame overflow-hidden bg-sand">
                  <img src={p.image} alt={p.title} loading="lazy" className="aspect-[3/4] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <p className="mt-5 font-accent text-[10px] uppercase tracking-[0.22em] text-terra">{p.category} · {formatDate(p.created_at)}</p>
                <h3 className="mt-2 font-serif text-2xl leading-snug text-forest transition-colors duration-300 group-hover:text-moss">{p.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-sage">{p.excerpt}</p>
              </Link>
            </FadeUp>
          ))}
        </div>
      </section>
    </main>
  );
}
